export var KeyCodes = {
  lo: 32,
  yo: 9,
  Ze: 13,
  Oh: 27
};